import React, { useEffect, useState, useRef } from "react";
import {
    MDBBtn,
    MDBSpinner,
    MDBStepper,
    MDBStepperStep,
    MDBAutocomplete,
    MDBAccordion,
    MDBAccordionItem,
    MDBIcon,
    MDBListGroup,
    MDBListGroupItem,
    MDBCheckbox,
    MDBBadge
} from "mdb-react-ui-kit";
import { formattedNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
import { sendRequestTnRelase } from "../../apiclients/streamsapi_bridge";

const customDefData = [
    { title: 'Harish', subtitle: 'State Name' },
    { title: 'Two', subtitle: 'Secondary text' },
    { title: 'Three', subtitle: 'Secondary text' },
    { title: 'Four', subtitle: 'Secondary text' },
    { title: 'Five', subtitle: 'Secondary text' },
    { title: 'Six', subtitle: 'Secondary text' },
];
function AddNewPhoneNumberSearch(props) {
            console.log("props.addedNumber ::: " +JSON.stringify(props.addedNumber));


    const [customData, setCustomData] = useState(customDefData);

    const [hoverNumber, setHoverNumber] = useState("");

    const onCustomSearch = (value) => {
        const search = value?.toLowerCase() || "";
      
        setphoneNumbers(
          props.numberList.filter((item) =>
            item.phone_number.toLowerCase().includes(search)
          )
        );
      };

    const [isButtonClicked, setButtonClicked] = useState(false);
    const [phoneNumbers, setphoneNumbers] = useState([]);
    const [addNumber, setAddNumbers] = useState([]);
    const [reqEnablePhnumFlag, setReqEnablePhnumFlag] = useState(false);
    const handleButtonClick = async (e, phoneNumber, isSMS,province,lata,api) => {
        e.preventDefault();
        e.stopPropagation();
        const PhIndex = addNumber.findIndex(number => number.phone_number === phoneNumber);
        let updatedNumbers;
        if (PhIndex === -1) {
            let number = {
                phone_number: phoneNumber,
                is_sms_enabled: isSMS,
                is_toll_free: props.isTollfree,
                province: province,
                lata :lata,
                api : api ? api : false
            }

            updatedNumbers = [...addNumber, number];
        } else {
            let [info] = addNumber.filter(item => item.phone_number ==  phoneNumber)
            console.log("tnReserve ::: " + info);
            if (info.tnReserve) {
                console.log("tnReserve ::: " +info.tnReserve);
                let tnReleaseParams = [
                    {
                        phone_number: phoneNumber,
                    }]
                let tnReleaseInfo = await sendRequestTnRelase(tnReleaseParams);
                let responseData = await tnReleaseInfo.json();
                console.log("responseData ::: " + JSON.stringify(responseData))
            }
            console.log("handleButtonClick to Delete::::::::: " + phoneNumber);

            updatedNumbers = addNumber.filter(number => number.phone_number !== phoneNumber);
        }
        setAddNumbers(updatedNumbers);
        props.PurchaseNum(updatedNumbers);
    };

    useEffect(() => {
        // alert(numberList.length);
        if (props.numberList && props.numberList.length > 0) {
            console.log("Numberlist :::::: " + JSON.stringify(props.numberList));
            console.log("props.addedNumber ::: " +JSON.stringify(props.addedNumber));
            setphoneNumbers(props.numberList);
            setAddNumbers(props.addedNumber);
            setReqEnablePhnumFlag(true);

        } else {
            setReqEnablePhnumFlag(false);
        }
    }, [props.numberList]);

    const handleMouseEnter = (phnum) => {
        setHoverNumber(phnum);

    };

    const handleMouseLeave = () => {
        setHoverNumber("");
    };

    return (
        <>
            <MDBAutocomplete
                disabled={props.disableMainSearch}
                data={phoneNumbers}
                label={`Search ${props.isTollfree ? 'Toll-Free' : 'Local'} Numbers`}
                displayValue={(row) => formattedNumber(row.phone_number)}
                onSearch={onCustomSearch}
                // open={reqEnablePhnumFlag}
                itemContent={(result) => (
                    <div className='autocomplete-custom-item-content d-flex justify-content-between w-100 align-items-center'>
                        <div>
                            <div>
                                <div className='autocomplete-custom-item-title'>{formattedNumber(result.phone_number)}
                                    {result.is_sms_enabled === 1 && (
                                        <MDBBadge color="primary" title="SMS Capable" className="fw-400"><MDBIcon far icon="comment-alt" /></MDBBadge>
                                    )}
                                </div>
                                {/* <small className='autocomplete-custom-item-subtitle text-secondary'>{result.subtitle}</small> */}

                            </div>
                        </div>

                        <MDBBtn
                            size="sm"
                            color={addNumber.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'danger' : 'success') : 'primary'}
                            onClick={(e) => handleButtonClick(e, result.phone_number, result.is_sms_enabled,result.province,result.lata,result?.api ?? false)}  
                            onMouseEnter={() => handleMouseEnter(result.phone_number)} // Call the function
                            onMouseLeave={() => handleMouseLeave()} // Call the function
                            className="shadow-0"
                        >
                            <MDBIcon
                                fas
                                icon={addNumber.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'times' : 'check') : 'plus'}
                                color="white"
                                style={{ fontSize: 10 }}
                            />
                            <span className={addNumber.some(item => item.phone_number === result.phone_number) ? `ms-2 text-light w-40px` : `ms-2 text-light`} style={{ fontSize: 11, width: "50px" }}>
                                {addNumber.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'Remove' : 'Added') : 'Add'}
                            </span>
                        </MDBBtn>






                        {/* <MDBBtn
                            size="sm"
                            color={addNumber.some(item => item.phone_number === result.phone_number) ? 'danger' : 'primary'}
                            onClick={(e) => handleButtonClick(e, result.phone_number, result.is_sms_enabled)}
                        >
                            <MDBIcon fas icon={addNumber.some(item => item.phone_number === result.phone_number) ? 'remove' : 'plus'} color="white" style={{ fontSize: 12 }} />
                            <span className="ms-1 text-light">
                                {addNumber.some(item => item.phone_number === result.phone_number) ? 'Remove' : 'Add'}
                            </span>
                        </MDBBtn> */}

                    </div>
                )}
            />
        </>
    )
}
export default AddNewPhoneNumberSearch